const getDropdownItems = (item) => {
    if (item.children && item.children.length > 0) {
        return [...item.children];
    }
    return [];
};
export { getDropdownItems };
